import http from '../core/http-common'
import {
  IDashboardSummary,
  IOnCampusCoiffeurServiceAllFirmsStatistics,
  IOnCampusCoiffeurServiceStatisticsByLocation,
  IOnCampusHealthServiceAllFirmsStatistics,
  IOnCampusHealthServiceStatisticsByLocation,
  IOnCampusServiceStatisticsRequest,
} from '../types/DashboardType'

class DashboardService {
  getDashboardSummary(request: any) {
    return http.post<IDashboardSummary>(`/Dashboard/GetDashboardSummaryChart`, request)
  }
  getDashboardNotificationChart(request: any) {
    return http.post<any>(`/Dashboard/GetDashboardNotificationChart`, request)
  }
  getNotificationFirmUser(request: any) {
    return http.post<any>(`/Dashboard/GetDashboardUserChart`, request)
  }
  getDashboardOccupancy(request: any) {
    return http.post<any>(`/Dashboard/GetDashboardOccupancyChart`, request)
  }
  getDashboardChannel(request: any) {
    return http.post<any>(`/Dashboard/GetDashboardChannelChart`, request)
  }

  /* Health Services */
  getCampusHealthServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceAllFirmsStatistics>(`/Statistic/GetAllFirmStatistics`, request)
  }

  getCampusHealthServiceStatisticsByLocation(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceStatisticsByLocation[]>(`/Statistic/GetLocationStatistics`, request)
  }

  /* Coiffeur  */
  getCampusCoiffeurServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusCoiffeurServiceAllFirmsStatistics>(`/CoiffeurStatistic/GetAllFirmStatistics`, request)
  }

  getCampusCoiffeurServiceStatisticsByLocation(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusCoiffeurServiceStatisticsByLocation[]>(
      `/CoiffeurStatistic/GetLocationStatistics`,
      request
    )
  }

  /* Gym */
  getCampusGymPersonalServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceAllFirmsStatistics>(`/GymStatistic/GetAllPersonalFirmStatistics`, request)
  }
  getCampusGymGroupServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceAllFirmsStatistics>(`/GymStatistic/GetAllGroupLessonFirmStatistics`, request)
  }
  getCampusGymTrainerServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceAllFirmsStatistics>(`/GymStatistic/GetAllTrainerFirmStatistics`, request)
  }

  /* Lactation Room */
  getCampusLactationServiceStatistics(request: IOnCampusServiceStatisticsRequest) {
    return http.post<IOnCampusHealthServiceAllFirmsStatistics>(
      `/LactationStatistic/GetAllReservationFirmStatistics`,
      request
    )
  }
}

export default new DashboardService()
